export default function Pricing() {
  return (
    <div className="page">
      <h1>Pricing</h1>

      <div>
        <h3>Free</h3>
        <p>Basic features, limited members</p>
      </div>

      <div>
        <h3>Pro – ₦5,000/month</h3>
        <p>Full finance + unlimited members</p>
      </div>

      <div>
        <h3>Premium – ₦10,000/month</h3>
        <p>Advanced features + priority support</p>
      </div>
    </div>
  );
}
